import ModalCard from "components/common/Modal/ModalCard";
import styled from "styled-components";
import { DefaultTitle } from "../Styled";
const ModalBody = styled.div`
  color: var(--palette-ss-black, #4a4a4a);
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const Title = styled(DefaultTitle)`
  white-space: pre-wrap;
`;

const CustomModalCard = styled.div`
  position: relative;
  width: calc(100dvw - 42px);
  background: var(--palette-ss-white, #fff);
  border-radius: 30px;
  max-width: 632px;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 234px;
  padding: 22px 25px;
  border-radius: 5px;

  resize: none;

  &::placeholder {
    color: #c1c1c1;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
`;

export default { ModalBody, Title, CustomModalCard, TextArea };
